import { useMemo } from 'react';
import PropTypes from 'prop-types';

import {
  DESIGN_REVIEW_STATUS,
  DESIGN_REVIEW_STATUS_DISPLAY,
} from 'utlis/constants';

const StatusBadge = ({ status: statusProp }) => {
  const {
    circleBG,
    statusText,
  } = useMemo(() => {
    switch (statusProp) {
      case DESIGN_REVIEW_STATUS.FAILURE:
        return {
          circleBG: 'bg-red-400',
          statusText: DESIGN_REVIEW_STATUS_DISPLAY[DESIGN_REVIEW_STATUS.FAILURE],
        };
      case DESIGN_REVIEW_STATUS.DONE:
        return {
          circleBG: 'bg-green-400',
          statusText: DESIGN_REVIEW_STATUS_DISPLAY[DESIGN_REVIEW_STATUS.DONE],
        };
      case DESIGN_REVIEW_STATUS.FETCHING_FRAME:
      case DESIGN_REVIEW_STATUS.ANALYSING_SECTIONS:
      case DESIGN_REVIEW_STATUS.ANALYSING_DESIGN:
      case DESIGN_REVIEW_STATUS.SUMMARISING_FEEDBACK:
        return {
          circleBG: 'bg-yellow-400',
          statusText: DESIGN_REVIEW_STATUS_DISPLAY[DESIGN_REVIEW_STATUS.FETCHING_FRAME],
        };
      default:
        return {
          circleBG: null,
          statusText: 'Unknown',
        };
    }
  }, [statusProp]);

  return (
    <span
      className={`
        flex items-center gap-[6px] px-2 py-[2px] rounded-full border 
        border-figma-gray-200 bg-white text-sm font-medium max-h-[24px] 
        text-figma-gray-600 px-8 py-2
      `}
    >
      {circleBG && (
        <span className={`w-2 h-2 rounded-full ${circleBG}`} />
      )}
      {statusText}
    </span>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.number.isRequired,
};

export default StatusBadge;
